export interface ConfirmationFormValues {
  code: string;
  phone_number: string;
}

export interface UserInfoFormikValues {
  email?: string;
  tosConsent: boolean;
  phone?: string;
}

export interface VerifyPhoneAttributes extends UserInfoFormikValues {
  domain: string;
  user_id: string;
  optin_method: string;
  phone_number: string;
}

export interface CreateUserAttributes extends ConfirmationFormValues {
  user_id: string;
  optin_method: string;
  domain: string;
  phone_number: string;
}

export enum WorkflowStep {
  Initial,
  Confirm,
  Success,
}

export type DisplayType = "modal" | "page";
